// utils/passwordValidation.js
export const validatePassword = (password) => {
  const errors = [];
  
  if (password.length < 8) {
    errors.push('Au moins 8 caractères');
  }
  
  if (!/[a-z]/.test(password)) {
    errors.push('Au moins une minuscule');
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push('Au moins une majuscule');
  }
  
  if (!/\d/.test(password)) {
    errors.push('Au moins un chiffre');
  }
  
  if (!/[^a-zA-Z\d]/.test(password)) {
    errors.push('Au moins un caractère spécial');
  }
  
  return {
    isValid: errors.length === 0,
    errors,
    strength: calculatePasswordStrength(password)
  };
};

export const calculatePasswordStrength = (password) => {
  let strength = 0;
  if (password.length >= 8) strength += 20;
  if (password.length >= 12) strength += 20;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) strength += 20;
  if (/\d/.test(password)) strength += 20;
  if (/[^a-zA-Z\d]/.test(password)) strength += 20;
  return Math.min(strength, 100);
};

export const getStrengthColor = (strength) => {
  if (strength < 40) return 'red';
  if (strength < 70) return 'orange';
  return 'green';
};

export const getStrengthText = (strength) => {
  if (strength < 40) return 'Faible';
  if (strength < 70) return 'Moyen';
  return 'Fort';
};